"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const TabTitle_1 = __importDefault(require("./TabTitle"));
const TabContent_1 = require("../TabContent");
const Logo_1 = __importDefault(require("../Logo"));
const inventory_1 = require("../../theme/inventory");
const BetaTag_1 = __importDefault(require("../BetaTag"));
const Tabs = props => {
  const {
    children,
    bgColor,
    contentBgColor,
    onClick,
    fixed,
    showLogo,
    showBetaTag,
    rightRegion,
    mobile
  } = props;
  const [selectedTab, setSelectedTab] = react_1.default.useState(0);
  let activeTab = children ?
  // @ts-ignore
  children.findIndex(item => item.props.selected) : -1;
  if (children && activeTab === -1) {
    activeTab = 0;
  }
  const onSelected = tabIndex => {
    if (onClick) {
      if (children && tabIndex > -1) {
        // @ts-ignore
        onClick(children[tabIndex].props);
      }
    } else {
      setSelectedTab(tabIndex);
    }
  };
  let content;
  if (children) {
    if (onClick) {
      // @ts-ignore
      content = children[activeTab].props.children;
    } else {
      // @ts-ignore
      content = children[selectedTab].props.children;
    }
  }
  return (0, jsx_runtime_1.jsxs)(styles_1.StyledTabsWrapper, {
    fixed: fixed,
    mobile: mobile,
    className: 'tabs-primary',
    children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledPanel, {
      bgColor: bgColor,
      children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledLeftPanel, {
        children: [showLogo && (0, jsx_runtime_1.jsx)(styles_1.StyledLogo, {
          children: (0, jsx_runtime_1.jsxs)("div", {
            style: {
              position: 'relative'
            },
            children: [(0, jsx_runtime_1.jsx)(Logo_1.default, {
              fill: inventory_1.GENERAL_COLOR_VALUES.white
            }), showBetaTag && (0, jsx_runtime_1.jsx)(BetaTag_1.default, {
              isLight: true
            })]
          })
        }), (0, jsx_runtime_1.jsx)(styles_1.StyledPrimaryTabs, {
          bgColor: bgColor,
          children: children?.map((item, index) => {
            return (0, jsx_runtime_1.jsx)(TabTitle_1.default, {
              title: item.props.title,
              tabIndex: index,
              onSelect: onSelected,
              isSelected: index === (onClick ? activeTab : selectedTab),
              badgeValue: item.props.badgeValue,
              bgColor: bgColor,
              name: item.props.name,
              badgeProps: item.props.badgeProps,
              mobile: mobile
            }, `tab-${index}`);
          })
        })]
      }), rightRegion && (0, jsx_runtime_1.jsx)(styles_1.StyledRightPanel, {
        children: rightRegion
      })]
    }), (0, jsx_runtime_1.jsx)(TabContent_1.TabContent, {
      bgColor: contentBgColor,
      children: content
    })]
  });
};
exports.default = Tabs;